import { RootState } from '../../../store';

export const getExerciseSelector = (state: RootState) =>
  state.exerciseOfTheDay.exercise;
export const getLoadingExerciseSelector = (state: RootState) =>
  state.exerciseOfTheDay.isLoading;
export const getExerciseErrorsSelector = (state: RootState) =>
  state.exerciseOfTheDay.errors;
